module.exports = __webpack_public_path__ + "img/inputBg.a808f14e.png";